import React from 'react';
import '../styles/Sidebar.css';

const Sidebar = ({ activeSection, onSectionChange, isOpen, onToggle, user }) => {
  const menuItems = [
    { id: 'dashboard', icon: '📊', label: 'Dashboard' },
    { id: 'referral', icon: '🔗', label: 'Referral Tools' },
    { id: 'earnings', icon: '💰', label: 'Earnings' }
  ];

  const handleItemClick = (itemId) => {
    onSectionChange(itemId);
    // Close sidebar on mobile after selection
    if (window.innerWidth <= 768) {
      onToggle();
    }
  };

  const getUserInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={onToggle}></div>
      )}
      
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          
          <div className="sidebar-brand">
            <div className="brand-logo-compact">
              <img src="./logo.png" alt="USingle2" className="brand-logo" />
            </div>
            <h2>USingle2</h2>
          </div>
          
          {/* Close button for mobile */}
          <button className="sidebar-close-btn" onClick={onToggle}>
            ×
          </button>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <button
              key={item.id}
              className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => handleItemClick(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>
        
        <div className="sidebar-footer">
          <div className="user-info-sidebar">
            <div className="user-avatar">
              {getUserInitials(user?.first_name + ' ' + user?.last_name)}
            </div>
            <div className="user-details">
              <span className="user-name-sidebar">
                {user?.first_name + ' ' + user?.last_name || 'User'}
              </span>
              <span className="user-role">Affiliate</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;